import {
  Center,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'
import React from 'react'

import { useTranslations } from '~shared-components/hooks/useTranslations'
import { IconTranslate } from '~shared-components/icons/brand/IconTranslate'

import { LeadText } from '../Typography/Typography'
import { GenericModalFooter } from './GenericModalFooter'
import { ModalCloseButton } from './ModalCloseButton'

interface LanguageSelectionModalProps {
  isLoading: boolean
  isOpen: boolean
  onChange: () => void
  onClose: () => void
}
export const LanguageSelectionModal = ({
  isLoading,
  isOpen,
  onChange,
  onClose,
}: LanguageSelectionModalProps) => {
  const t = useTranslations()
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      motionPreset="scale"
      onClose={onClose}
      size="lg"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading
            color="deepPurple"
            size="xl"
            textAlign="left"
            textTransform="capitalize"
          >
            {t('languageselection.modal.title')}
          </Heading>
        </ModalHeader>
        <ModalCloseButton aria-label="close" onClose={onClose} />
        <ModalBody>
          <VStack alignItems="flex-start" spacing={5} w="100%">
            <LeadText bold>{t('languageselection.modal.areyousure')}</LeadText>
            <Center w="100%">
              <IconTranslate boxSize="88px" color="neutral.50" my={4} />
            </Center>
            <LeadText>{t('languageselection.modal.description')}</LeadText>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <GenericModalFooter
            actionButtonId="modal-select-language-btn"
            actionTextLabel="languageselection.modal.confirm"
            isLoadingAction={isLoading}
            onAction={onChange}
            onCancel={onClose}
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
